module.exports = __webpack_public_path__ + "/login_ui/img/so-1642d33fd67a161426718e7742024eb0.svg";